import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("gunbuy_cookie_consent");
    if (!dismissed) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("gunbuy_cookie_consent", "accepted");
    setVisible(false);
    // Log to backend asynchronously
    axios.post(`${API}/auth/cookie-consent`, { consent: "accepted" }).catch(() => {});
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-slate-900 border border-slate-700 rounded-sm shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-slate-300 leading-relaxed">
            This site uses cookies and similar technologies to improve your experience, analyse traffic and serve relevant ads.
            By continuing to use GunBuy, you consent to our use of cookies. See our{" "}
            <Link to="/privacy" className="text-orange-400 hover:text-orange-300 underline underline-offset-2">Privacy Policy</Link> for details.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            onClick={accept}
            className="bg-orange-600 hover:bg-orange-700 text-white rounded-sm font-semibold h-9 px-6 text-sm"
            data-testid="cookie-accept-btn"
          >
            Accept
          </Button>
          <button
            onClick={accept}
            className="text-slate-400 hover:text-white p-1 transition-colors"
            aria-label="Dismiss"
            data-testid="cookie-dismiss-btn"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
